import * as React from 'react';
import Axios from 'axios';
import * as moment from 'moment';
import { colorSecondary } from 'src/variables';
import { IconPaths } from 'src/icons';
import { WeekDays, DateShortForms } from 'src/utils/dateHelper';

interface State {
  selectedDay: moment.Moment;
  items: [];
  controls: {
    next: boolean;
    prev: boolean;
  };
  err: boolean;
}

enum LogActionTypes {
  insert = 'Erstellen',
  update = 'Bearbeiten',
  remove = 'Löschen'
}

export default class LogsView extends React.Component<any, State> {
  current = moment().get('D');

  constructor(props: any) {
    super(props);
    this.state = {
      selectedDay: moment(),
      items: [],
      controls: {
        next: true,
        prev: true
      },
      err: false
    };
  }

  componentDidMount() {
    this.checkControls(moment(this.state.selectedDay).add(1, 'd'));
    this.getTextFile();
  }

  componentWillUnmount() {
    this.setItems([]);
  }

  getTextFile = () => {
    const nr = this.state.selectedDay.format('DD');

    Axios.get(`/logs/cardevents/evm-cardevents-${nr}.txt`)
      .then((res: any) => {
        const text = res.data;
        const data: any = [];
        if (typeof text === 'string' && text.startsWith('<!doctype')) {
          throw new Error('404 - File not found');
        }
        let split = null;
        try {
          split = text.split('\n');
          split.forEach((el: string) => {
            if (el.length > 2) {
              const json = JSON.parse(el);
              data.push(json);
            }
          });
        } catch {
          if (text) {
            data.push(text);
          }
        }
        console.log(data);
        this.setItems(data);
      })
      .catch((err: any) => {
        console.error(err);
        this.setState({ err: true });
      });
  };

  setItems = (allText: any) => {
    this.setState({
      items: allText,
      err: false
    });
  };

  onNext = () => {
    const day = moment(this.state.selectedDay).add(1, 'd');
    this.checkControls(day);
    this.setState({ selectedDay: day }, () => this.getTextFile());
  };

  onPrevious = () => {
    const day = moment(this.state.selectedDay).subtract(1, 'd');
    this.checkControls(day);

    this.setState({ selectedDay: moment(this.state.selectedDay).subtract(1, 'd') }, () =>
      this.getTextFile()
    );
  };

  checkControls = (day: moment.Moment) => {
    const controls = {
      next: true,
      prev: true
    };
    console.log('day', day);
    console.log('current', this.current);
    const diff = moment()
      .subtract(1, 'd')
      .diff(day, 'month');
    if (day.isSameOrAfter(moment(), 'd')) {
      controls.next = false;
    }
    if (diff > 0) {
      controls.prev = false;
    }
    this.setState({ controls });
  };

  renderWeekdays = (weekdays?: any[]) => {
    const ret = [];
    const myWeekdays: number[] = [];
    if (weekdays !== undefined) {
      weekdays.map(e => {
        myWeekdays.push(+e);
      });
    }
    for (const w in WeekDays) {
      if (!isNaN(Number(w)) && myWeekdays !== undefined) {
        ret.push(
          <li key={w} className={myWeekdays.indexOf(+w) !== -1 ? 'active' : ''}>
            <span>{DateShortForms[WeekDays[w]]}</span>
          </li>
        );
      }
    }
    return ret;
  };

  render() {
    return (
      <div className="container">
        <div className="row" style={{ marginBottom: '20px' }}>
          <div className="col-6">
            <h1>Logs</h1>
          </div>
          <div
            className="col-6"
            style={{
              textAlign: 'left',
              display: 'flex',
              alignItems: 'center',
              backgroundColor: colorSecondary
            }}
          >
            <button
              className="noStyle pointer"
              disabled={!this.state.controls.prev}
              onClick={this.onPrevious}
            >
              <img src={IconPaths['arrow-icon']} style={{ height: '20px' }} />
            </button>

            <span
              style={{
                fontSize: '1.3rem',
                fontWeight: 'bold',
                lineHeight: 0,
                padding: '0 10px',
                width: '230px'
              }}
            >
              {this.state.selectedDay.format('dddd DD.MM.')}
            </span>
            <button
              className="noStyle pointer"
              disabled={!this.state.controls.next}
              onClick={this.onNext}
            >
              <img
                className={`pointer ${this.state.controls.next ? '' : 'disabled'}`}
                src={IconPaths['arrow-icon']}
                style={{ transform: 'rotate(180deg)', height: '20px' }}
              />
            </button>
          </div>
        </div>
        <div className="col-12">
          <table className="closureManage_table">
            <thead>
              <tr>
                <th>Zeit</th>
                <th>Benutzer</th>
                <th>Aktion</th>
                <th>Event</th>
                <th>Wochentag</th>
                <th>Zeitraum</th>
              </tr>
            </thead>
            <tbody>
              {this.state.items &&
                !this.state.err &&
                this.state.items.length > 0 &&
                this.state.items.map((item: any, index: number) => (
                  <tr className="closureManage_item" key={index}>
                    <td style={{ paddingRight: 0 }}>
                      {moment(item.timestamp).format('DD.MM.YYYY HH:mm:ss')}
                    </td>
                    <td>{item.initiator.name}</td>
                    <td>{LogActionTypes[item.action]}</td>
                    <td className="closureManage_title" style={{ textAlign: 'center' }}>
                      {item.sampleEvent && item.sampleEvent.title}
                    </td>
                    {item.dateranges && (
                      <td className="closureManage_weekday">
                        <ul className="closureManage_weekday_ul">
                          {this.renderWeekdays(item.dateranges[0].weekdays)}
                        </ul>
                      </td>
                    )}

                    <td>
                      {item.dateranges &&
                        item.dateranges.map((d: any, i: number) => {
                          return (
                            <div key={i}>
                              {d.start && moment(d.start).format('DD.MM.YYYY')} -
                              {d.end && moment(d.end).format('DD.MM.YYYY')}
                            </div>
                          );
                        })}
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {this.state.err && (
            <h3 style={{ marginTop: '40px' }}>Für diesen Tag sind keine Logs vorhanden</h3>
          )}
        </div>
      </div>
    );
  }

  renderText = (items: any) => {
    const myItems = items.slice();
    const retVal: any = [];
    myItems.forEach((item: any, index: number) => {
      if (
        item.action === 'remove' &&
        items.length > index + 1 &&
        items[index + 1].action === 'insert'
      ) {
        item.action = 'update';
        items.splice(index + 1, 1);
      }
      retVal.push();
    });
    return retVal;
  };
}



// WEBPACK FOOTER //
// ./src/pages/Management/LogView/LogsView.tsx